<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  fill="none"
  viewBox="0 0 16 15"
>
  <path
    [attr.fill]="color"
    d="M7.31667 15L9.21467 13.1147L5.09733 8.99733L16 8.99733L16 6.336L5.09733 6.336L9.21467 2.21867L7.31667 0.333334L-6.411e-07 7.66667L7.31667 15Z"
  />
</svg>
